var engine = {};


engine.now = function(){
};

engine.today = function(){
};

module.exports = engine;
